import { Navigate, useLocation } from "react-router-dom";
import { useAuthState } from "/app/src/contexts/authentication";
import { useDashboardPermission } from "/app/src/hooks/useDashboardPermission";
import { useAppsPermission } from "/app/src/hooks/useAppsPermission";

// Redirects to the login
// screen if you're not yet authenticated.
export default function PrivateRoute({
  children = null,
}: {
  children?: JSX.Element;
}) {
  const { isAuthenticated } = useAuthState();
  const location = useLocation();
  const { dashboardLocked } = useDashboardPermission();
  const { appsLocked } = useAppsPermission();
  if (isAuthenticated) {
    // dashboardLocked takes precedence over appsLocked if both are set
    if (dashboardLocked && location.pathname !== "/dashboard") {
      return (
        <Navigate
          to={{
            pathname: "/dashboard",
          }}
          state={{ from: location.pathname }}
        />
      );
    } else if (appsLocked && !location.pathname.startsWith("/apps")) {
      return (
        <Navigate
          to={{
            pathname: "/apps",
          }}
          state={{ from: location.pathname }}
        />
      );
    } else {
      return children;
    }
  } else {
    return (
      <Navigate
        to={{
          pathname: "/login",
        }}
        state={{ from: location.pathname }}
      />
    );
  }
}
